/* ==========================================================================
   SYKELL — Page « Notre engagement »
   JS vanilla · aucune dépendance · thème Concept
   ========================================================================== */
(function () {
  'use strict';
  if (!window || !document) return;
  var root = document.getElementById('sykell-engagement');
  if (!root) return;

  /* ----- 1. Smooth scroll des ancres internes ----- */
  root.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.length < 2) return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  /* ----- 2. FAQ : un seul détail ouvert à la fois ----- */
  var detailsList = root.querySelectorAll('.sye-faq__list details');
  detailsList.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      detailsList.forEach(function (other) {
        if (other !== d) other.open = false;
      });
    });
  });

  /* ----- 3. Reveal on scroll ----- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    var revealTargets = root.querySelectorAll(
      '.sye-assurance__item, .sye-why__card, .sye-eng__card, .sye-step, ' +
      '.sye-member, .sye-stat, .sye-testimonial, .sye-guide, .sye-faq__list details'
    );
    revealTargets.forEach(function (el) {
      el.classList.add('is-reveal');
      io.observe(el);
    });
  }
})();
